// extracted by mini-css-extract-plugin
export default {"periodTimeContainer":"PeriodTimePicker_periodTimeContainer__FY2IQ","arrowIcon":"PeriodTimePicker_arrowIcon__wMqtA","opened":"PeriodTimePicker_opened__35cbB"};